import { IFile, IFileUploaderOptions, IResponse, ProcessivePromise, UploadFile } from "@core/lib/file-uploader";
import { FileUploaderService } from "./file-uploader.service";

export class FileUploaderV2Provider implements angular.IServiceProvider {

    private DEFAULT_OPTIONS: IFileUploaderOptions = {
        autoUpload: true,
        // isHTML5: true,
        method: "POST",
        maxFileSize: 300 * 1024 * 1024,
        queueLimit: 10,
        isPatchUpload: true,
        removeAfterUpload: false,
        disableMultipart: false,
        formatDataFunctionIsAsync: false,
        chunkSize: 10 * 1024 * 1024,
        url: ""
    };

    private options: IFileUploaderOptions;

    setUrl(url: string): void {
        this.options.url = url;
    }

    setOptions(options: Partial<IFileUploaderOptions>): void {
        if (options) {
            this.options = Object.assign(this.DEFAULT_OPTIONS, options);
        }
    }

    constructor() {
        this.options = angular.copy(this.DEFAULT_OPTIONS);
    }

    public $get = ["qpFileUploaderJobFactory", "globalUniqueIdService", "eventBus", (jboFactory: (pendingFile: UploadFile, options: IFileUploaderOptions) => ProcessivePromise<IResponse<IFile>>, globalUniqueIdService, eventBus) => {
        // let jboFactory: (pendingFile: UploadFile, options: IFileUploaderOptions) => ProcessivePromise<IResponse<IFile>> = $injector.get('qpFileUploaderJobFactory');
        return new FileUploaderService(globalUniqueIdService, eventBus, jboFactory, this.options);
    }];

}